import { gql } from "@apollo/client";

export const CREATE_STARTUP_MUTATION = gql`
  mutation CreateStartup($input: StartupInput!) {
    createStartup(input: $input) {
      statusCode
      message
    }
  }
`;
